exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".search-result {\n  display: inline-block;\n  width: calc(100% - 20px);\n}\n.search-result > span + span {\n  margin-left: 6px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/search/infrastructure/searchResult.less
// module id = 2629
// module chunks = 0